import { RouteConfig } from 'vue-router';

import Projects from './projects/index.vue';
import Project from './project/index.vue';
import Students from './students/index.vue';
import Student from './student/index.vue';
import OnboardingApplication from './onboarding_application/index.vue';
import OnboardingApplications from './onboarding_applications/index.vue';
import ppmRoutes from './ppm/routes';
import lnplRoutes from './lnpl/routes';
import Orders from './orders/index.vue';
import PpmOrder from './ppm/views/order/index.vue';
import LnplOrder from './lnpl/views/order/index.vue';

export const routes: Array<RouteConfig> = [
  {
    path: '',
    component: () => import('./index.vue'),
    children: [
      ...ppmRoutes,
      ...lnplRoutes,
      {
        path: 'projects',
        component: Projects,
        meta: {
          title: 'Projects',
        },
      },
      {
        path: 'projects/:id',
        component: Project,
        meta: {
          title: 'Project',
        },
      },
      {
        path: 'students',
        component: Students,
        meta: {
          title: 'Students',
        },
      },
      {
        path: 'students/:id',
        component: Student,
        meta: {
          title: 'Student',
        },
      },
      {
        path: 'orders',
        component: Orders,
        meta: {
          title: 'Orders',
        },
      },
      {
        path: 'orders/ppm/:id',
        component: PpmOrder,
      },
      {
        path: 'orders/lnpl/:id',
        component: LnplOrder,
      },
      {
        path: 'onboarding-applications',
        component: OnboardingApplications,
        meta: {
          title: 'Onboarding Applications',
        },
      },
      {
        path: 'onboarding-applications/:id',
        component: OnboardingApplication,
        meta: {
          title: 'Onboarding Application',
        },
      },
    ],
  },
];

export default routes;
